// extracted by mini-css-extract-plugin
export default {"max-diff-announcement":"MaxDiffAnnouncement_max-diff-announcement__8Oo3t","max-diff-announcement-help-icon":"MaxDiffAnnouncement_max-diff-announcement-help-icon__c4O6X"};